import { Grid, makeStyles, Typography, Paper } from '@material-ui/core'
import Button from '../../../control/button/button'
import { FC } from 'react'
import { Form } from 'react-final-form'
import Select from '../../../control/select/select'
import useTranslate from '../../../i18n/useTranslate'
import { SettingDocumentSearchform } from '../../../pages/SettingDocument'
import useIRB from '../../../services/um/lookups/useIRB'
import useProjectStatus from '../../../services/um/lookups/useProjectStatus'
import MultiSelect from '../../../control/multiSelect/multiSelect'

type PanelProps = {
    onSubmit: (values: SettingDocumentSearchform) => void
    initialValue: SettingDocumentSearchform
    onReset: (form: any) => void
}

const Panel: FC<PanelProps> = ({ onSubmit, initialValue, onReset }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const { projectStatus } = useProjectStatus()
    const { irb } = useIRB()
    const defaultREC = initialValue.rec ? [initialValue.rec.toString()] : []
    const defaultSubmittedType = initialValue.submittedType ? [initialValue.submittedType] : []

    return (
        <Form onSubmit={onSubmit} initialValues={initialValue}>
            {({ handleSubmit, form }) => {
                return (
                    <Grid container spacing={2} className={classes.root}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Select
                                name="rec"
                                option={irb}
                                label={translate.get('UM.SETTINGDOCUMENT.SEARCH.REC')}
                                placeholder={translate.get('UM.SETTINGDOCUMENT.SEARCH.REC')}
                                size="small"
                                defaultValue={defaultREC}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Select
                                name="submittedType"
                                option={projectStatus}
                                label={translate.get('UM.SETTINGDOCUMENT.SEARCH.PROJECT_SUBMIT_TYPE')}
                                placeholder={translate.get('SETTINGDOCUMENT.SEARCH.PROJECT_SUBMIT_TYPE')}
                                size="small"
                                defaultValue={defaultSubmittedType}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="default"
                                        onClick={() => {
                                            form.reset()
                                            onReset(form)
                                        }}
                                        className={classes.btnSearch}
                                    >
                                        {translate.get('BUTTON.RESET')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        className={classes.btnSearch}
                                    >
                                        {translate.get('BUTTON.SEARCH')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </Form>
    )
}

export default Panel

const useStyles = makeStyles((theme) => ({
    reset: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    root: {
        padding: '15px',
    },
    btnSearch: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))
